import { Injectable, signal, inject } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { filter } from 'rxjs';
import { BreadcrumbCrumb } from '@core/models/breadcrumb-crumb';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbLabel {
  private readonly router = inject(Router);

  private readonly labels = signal<Record<string, string>>({});

  public readonly labelsReadonly = this.labels.asReadonly();

  constructor() {
    this.router.events.pipe(filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(() => {
      const crumbs = this.currentBreadcrumb();
      if (!crumbs) {
        return;
      }
      const dynamicKeys = crumbs.filter((c): c is { key: string; link?: unknown[] } => 'key' in c).map((c) => c.key);
      this.clearKeys(dynamicKeys);
    });
  }

  public setLabel(key: string, label: string): void {
    this.labels.update((map) => ({ ...map, [key]: label }));
  }

  public clearKeys(keep: string[]): void {
    this.labels.update((map) => {
      const next: Record<string, string> = {};
      for (const k of keep) {
        const v = map[k];
        if (v !== undefined) {
          next[k] = v;
        }
      }
      return next;
    });
  }

  private currentBreadcrumb(): BreadcrumbCrumb[] | null {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data['breadcrumb'] ?? null;
  }
}
